import StaffsPage from './StaffsPage';

export default StaffsPage;
